import type { IconNode } from '../types';

/**
 * @name hockey-mask
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMiAxMmExMCAxMCAwIDEgMCAyMCAwYzAtNC4xLS40LTYuNi0xLjktOC4xUzE2LjEgMiAxMiAycy02LjYuNC04LjEgMS45UzIgNy45IDIgMTIiIC8+CiAgPHBhdGggZD0iTTEyIDZoLjAxIiAvPgogIDxjaXJjbGUgY3g9IjgiIGN5PSIxMC41IiByPSIyIiAvPgogIDxjaXJjbGUgY3g9IjE2IiBjeT0iMTAuNSIgcj0iMiIgLz4KICA8cGF0aCBkPSJNOC41IDE3aC4wMSIgLz4KICA8cGF0aCBkPSJNMTIgMTVoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xNS41IDE3aC4wMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/hockey-mask
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const hockeyMask: IconNode = [
  [
    'path',
    {
      d: 'M2 12a10 10 0 1 0 20 0c0-4.1-.4-6.6-1.9-8.1S16.1 2 12 2s-6.6.4-8.1 1.9S2 7.9 2 12',
      key: '1j5pi6',
    },
  ],
  ['path', { d: 'M12 6h.01', key: '1vi96p' }],
  ['circle', { cx: '8', cy: '10.5', r: '2', key: '1ifbbn' }],
  ['circle', { cx: '16', cy: '10.5', r: '2', key: '7cttfh' }],
  ['path', { d: 'M8.5 17h.01', key: '1mvp11' }],
  ['path', { d: 'M12 15h.01', key: 'q59x07' }],
  ['path', { d: 'M15.5 17h.01', key: '1kw5ju' }],
];

export default hockeyMask;
